import {
  Accordion,
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
} from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { useState } from "react";

import { ButtonInternalLink } from "../components/ButtonInternalLink";

export function ShiftTransferableInfo() {
  const [accordionExpanded, setAccordionExpanded] = useState(true);

  return (
    <ListItem divider>
      <ListItemIcon iconType="swap-horizontal" />
      <ListItemText
        primary={
          <Accordion
            title="Transferable"
            expanded={accordionExpanded}
            LinkComponent={ButtonInternalLink}
            onChange={() => {
              setAccordionExpanded(!accordionExpanded);
            }}
          >
            <Stack sx={{ px: 2 }} spacing={4}>
              <Text variant="body2">You can transfer this shift to an eligible professional.</Text>
              <Text variant="body2">
                If the professional works the shift, your Clipboard Score will not be affected!
              </Text>
              <Text variant="body2">
                If they cancel or No Call No Show, you will lose 30 points.
              </Text>
              <Text variant="body2">Shifts can only be transferred once.</Text>
            </Stack>
          </Accordion>
        }
      />
    </ListItem>
  );
}
